import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import i18n from "i18next";
import Cookies from "js-cookie";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

const fallbackLng = 'en';
const supportedLngs = ['en', 'de', 'es', 'fr'];

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs,
    fallbackLng,
    defaultNS: 'translation',
    detection: {
      order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'span'],
    },
  });

// Задаем язык по умолчанию в куки
const detectedLang = Cookies.get("i18next");
const storedLang = supportedLngs.includes(detectedLang) ? detectedLang : fallbackLng;
i18n.changeLanguage(storedLang);
Cookies.set("i18next", storedLang);

export default i18n;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
